export const experienceData = [
    {
        id: 1,
        company: 'SAE NIT Durgapur',
        jobtitle: 'Web Developement Head',
        startYear: '2020',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'RECursion NIT Durgapur',
        jobtitle: 'Web and Tech Head',
        startYear: '2020',
        endYear: 'present'
    },
    {
        id: 3,
        company: 'Webmaster',
        jobtitle: 'TEDX NIT Durgapur',
        startYear: '2021',
        endYear: 'Present'
    },
]